import React from 'react'

import { AspectContainer } from 'components/layout'
import { Icon, Image } from 'components/dataDisplay'


export const bgColors = {
  'white': 'fff',
  'light-beige': 'f7efe9',
  'gray-10': 'fafafa',
  'gray-20': 'f0f0f0',
  'gray-30': 'dadada',
}

export type BgColor = keyof typeof bgColors | string

export type ProductImageProps = {
  className?: string
  bgColor?: BgColor
  src: string
  alt?: string
  fit?: 'cover' | 'contain'
  lazy?: boolean
}

const ProductImage: React.FunctionComponent<ProductImageProps> = (props) => {
  const { className, src, alt, bgColor = 'white', fit = 'contain', lazy } = props

  if (!src) {
    return (
      <AspectContainer className={className} fit={fit}>
        <Icon name="other/product" />
      </AspectContainer>
    )
  }

  return (
    <AspectContainer className={className} fit={fit}>
      <Image
        src={src}
        alt={alt}
        bgColor={bgColors[bgColor]}
        lazy={lazy}
      />
    </AspectContainer>
  )
}


export default ProductImage
